'use client';

import { c as _c } from "react/compiler-runtime";
import { BuilderBlocks } from '@builder.io/react';
import { type BuilderBlock } from '@builder.io/react/dist/types/src/components/builder-block.component';
import Link from 'next/link';
import React from 'react';
import { Container, type ContainerProps } from '@src/components/Container/Container';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import { cn } from '@src/utils/tailwind';
interface ResponsiveValue {
  desktop: number;
  mobile: number;
  tablet: number;
}
interface GridProps {
  columns: any[];
  space: number;
  responsiveColumns: ResponsiveValue;
  responsiveSpace: ResponsiveValue;
  containerWrapper: boolean;
  builderBlock: BuilderBlock;
  attributes: any;
  alignItems: 'center' | 'left' | 'right';
  innerSpacing: ContainerProps['innerSpacing'];
  outerSpacing: ContainerProps['outerSpacing'];
}
export const Grid = t0 => {
  const $ = _c(39);
  const {
    columns: t1,
    responsiveColumns,
    space,
    responsiveSpace,
    containerWrapper,
    builderBlock,
    attributes,
    alignItems,
    innerSpacing,
    outerSpacing
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const columns = t2;
  const {
    isMobile,
    isTablet
  } = useBreakpoints();
  const Wrapper = containerWrapper ? Container : "div";
  let t3;
  if ($[2] !== containerWrapper || $[3] !== innerSpacing || $[4] !== outerSpacing) {
    t3 = containerWrapper ? {
      innerSpacing,
      outerSpacing
    } : {};
    $[2] = containerWrapper;
    $[3] = innerSpacing;
    $[4] = outerSpacing;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const wrapperProps = t3;
  let filteredAttributes;
  let key;
  if ($[6] !== attributes) {
    const {
      style,
      key: t4,
      ...t5
    } = attributes;
    key = t4;
    filteredAttributes = t5;
    $[6] = attributes;
    $[7] = filteredAttributes;
    $[8] = key;
  } else {
    filteredAttributes = $[7];
    key = $[8];
  }
  const t4 = `lg:grid-cols-${responsiveColumns.desktop} md:grid-cols-${responsiveColumns.tablet} sm:grid-cols-${responsiveColumns.mobile}`;
  const t5 = alignItems !== "center";
  const t6 = alignItems === "center";
  let t7;
  if ($[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = cn(t4, {
      "builder-columns w-full": true,
      grid: t5,
      "flex flex-wrap items-center justify-center": t6
    });
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const flexClassName = t7;
  const flexBasis = `basis-[${100 / columns.length}]`;
  const t8 = alignItems !== "center";
  const t9 = alignItems === "center";
  const t10 = alignItems === "center";
  let t11;
  if ($[13] !== flexBasis || $[14] !== t10 || $[15] !== t8 || $[16] !== t9) {
    t11 = cn({
      "builder-column flex w-full flex-row": t8,
      "lg:flex lg:grow-1 lg:shrink-0": t9,
      [flexBasis]: t10
    });
    $[13] = flexBasis;
    $[14] = t10;
    $[15] = t8;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const columnClassName = t11;
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      left: "ltr",
      right: "rtl",
      center: "ltr"
    };
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const direction = t12;
  const gap = responsiveSpace?.desktop || responsiveSpace?.tablet || responsiveSpace?.mobile ? isMobile ? responsiveSpace?.mobile : isTablet ? responsiveSpace?.tablet : responsiveSpace?.desktop : space;
  const t13 = `${gap}px`;
  const t14 = direction[alignItems];
  let t15;
  if ($[19] !== t13 || $[20] !== t14) {
    t15 = {
      gap: t13,
      direction: t14
    };
    $[19] = t13;
    $[20] = t14;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] !== builderBlock?.id || $[23] !== columnClassName || $[24] !== columns) {
    let t17;
    if ($[26] !== builderBlock?.id || $[27] !== columnClassName) {
      t17 = (col, index) => {
        const TagName = col.link ? Link : "div";
        return <React.Fragment key={index}><TagName className={columnClassName} href={col.link || "#"}><BuilderBlocks key={index} className="w-full" fieldName="Block" parentElementId={builderBlock?.id} blocks={col.blocks} dataPath={`component.options.columns.${index}.blocks`} /></TagName></React.Fragment>;
      };
      $[26] = builderBlock?.id;
      $[27] = columnClassName;
      $[28] = t17;
    } else {
      t17 = $[28];
    }
    t16 = columns.map(t17);
    $[22] = builderBlock?.id;
    $[23] = columnClassName;
    $[24] = columns;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[29] !== flexClassName || $[30] !== t15 || $[31] !== t16) {
    t17 = <div className={flexClassName} style={t15}>{t16}</div>;
    $[29] = flexClassName;
    $[30] = t15;
    $[31] = t16;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== Wrapper || $[34] !== filteredAttributes || $[35] !== key || $[36] !== t17 || $[37] !== wrapperProps) {
    t18 = <Wrapper key={key} {...filteredAttributes} {...wrapperProps}>{t17}</Wrapper>;
    $[33] = Wrapper;
    $[34] = filteredAttributes;
    $[35] = key;
    $[36] = t17;
    $[37] = wrapperProps;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  return t18;
};